import { trackEvidenceUploaded } from '@/lib/analytics';

export async function uploadEvidenceWithMeasurement(
  uploadDocument: (claimId: string, file: File, type: 'auto') => Promise<unknown>,
  claimId: string,
  file: File
): Promise<void> {
  await uploadDocument(claimId, file, 'auto');
  trackEvidenceUploaded();
}
